// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ReviewsBlock_wrapper__i4B7U","header":"ReviewsBlock_header__5xItb","button":"ReviewsBlock_button__DPmud","list":"ReviewsBlock_list__LFhVF"};